import { Provider } from '@angular/core';
import { FormLoadingService } from '../form-loading/form-loading.service';
import { FormMessageService } from '../form-message.service';
import { HideEventService } from '../form-loading/hide-event.service';
import { FormNotifyService } from '../form-notify.service';
import { FormErrorService } from '../error/form-error.service';
import { CheckService } from '../check.service';
import { DataCheckService } from '../data-check.service';

import { EventService } from '../event.service';
import { MenuStateService } from '../menu-state.service';
import { RouterService } from '../router.service';
import { UIStateService } from '../ui-state.service';
import { StateMachineService } from '../state-machine.service';
import { ValidationService } from '../validation.service';
import { BindingDataService } from '../binding-data.service';
import { CommandService } from '../command-service';

import { QuerystringService } from '../querystring';
import { RuntimeFrameworkService } from '../rtf-service';
import { NavigationEventService } from '../navigation-event.service';
import { NavigationService } from '../navigation.service';
import { NavigationMiddlewareService } from '../navigation-middleware.service';
import { GridMiddlewareService } from '../grid.middleware.service';
import { ParamService } from '../param.service';

import { BeActionService } from '../be-action.service';
import { ApproveService } from '../approve.service';
import { PrintService } from '../print.service';
import { AttachmentDataService, AttachmentService } from '../attachment/index';
import { ApplicationParamService } from '../application-param.service';
import {
  EntityTraversingService, EntityManipulationService, EntityAggregationService,
  EntityListService, EntityService
} from '../entity-services/index';
import { LanguageService } from '../languag.service';
import { DialogService } from '../dialog.service';
import { SidebarService } from '../sidebar-service';
import { FarrisFormService } from '../farris-form.service';
import { FilterService } from '../filter-service';
import { ChangeItemService } from '../change-item.service';

// data-services
import { ListDataService } from '../data-services/list-data.service';
import { TreeDataService } from '../data-services/tree-data.service';
import { CardDataService } from '../data-services/card-data.service';
import { SubListDataService } from '../data-services/sub-list-data.service';
import { KeybindingService } from '../keybinding-service';
import { FocusInvalidService } from '../focus-invalid.service';
import { SubTreeDataService } from '../data-services/sub-tree-data-service';

/**
 * éççèProviders
 */
const FARRIS_COMMAND_SERVICE_PROVIDERS: Provider[] = [

  // è¡¨åæ¨¡åæ³¨å¥ï¼18ä¸ªï¼
  FormLoadingService,
  FormMessageService,
  FormNotifyService,
  FormErrorService,
  CheckService,
  DataCheckService,
  EventService,
  FilterService,
  KeybindingService,
  LanguageService,
  ParamService,
  MenuStateService,
  QuerystringService,
  RuntimeFrameworkService,
  NavigationEventService,
  NavigationService,
  RouterService,
  ApplicationParamService,

  // FrameComponentï¼20ä¸ªï¼
  ValidationService,
  FocusInvalidService,
  ChangeItemService,
  UIStateService,
  StateMachineService,
  BindingDataService,
  CommandService,

  // entity-services
  EntityTraversingService,
  EntityManipulationService,
  EntityAggregationService,
  EntityListService,
  EntityService,

  ListDataService,
  TreeDataService,
  SubTreeDataService,
  CardDataService,
  SubListDataService,

  BeActionService,
  ApproveService,
  PrintService,
  AttachmentDataService,
  AttachmentService,
  NavigationMiddlewareService,
  GridMiddlewareService,
  SidebarService,
  FarrisFormService,
  DialogService,
];

export { FARRIS_COMMAND_SERVICE_PROVIDERS };
